import React from 'react';
import {useSalesforceContactFieldQuery} from 'api';

interface Props {
  contactFieldId: string;
  value?: string;
}

export default ({contactFieldId, value}: Props) => {
  const {
    data: {
      salesforceContactField: {salesforceContactFieldSelectOptions = []} = {},
    } = {},
  } = useSalesforceContactFieldQuery({
    variables: {contactFieldId},
    skip: !contactFieldId,
  });

  const selectedOption = salesforceContactFieldSelectOptions?.find(
    (option) => option.id === value,
  );

  if (!selectedOption) {
    return null;
  }

  return (
    <div className="flex-1 flex flex-wrap items-center gap-1">
      <span className="h-6 flex items-center justify-center text-sm border border-c-border rounded-sm bg-c-bg px-2">
        {selectedOption.label}
      </span>
    </div>
  );
};
